import { render, staticRenderFns } from "./query__.vue?vue&type=template&id=1ecdffbf&"
import script from "./query__.vue?vue&type=script&lang=js&"
export * from "./query__.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports